import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {RUMHeaderInput, RUMTabData} from "@/lib/queries/rum";
import {PageLoadTrend} from "@/pages/rum/v2/details/graphs/RUMPageLoadTrend.tsx";
import {SectionBreakdown} from "@/pages/rum/v2/details/graphs/SectionBreakdown.tsx";
import {SectionSegments} from "@/pages/rum/v2/details/graphs/segments/SectionSegments.tsx";
import {RUMChartTab, RUMChartTabParams} from "@/pages/rum/v2/details/graphs/types.ts";
// @ts-expect-error legacy
import {ReportDefs} from "@/pages/rum/v2/details/ReportDefs.js";

import {SectionDistributionGraph} from "./SectionDistributionGraph.tsx";

interface PageLoadTimeGraphProps {
  checkName: string;
  id: number;
  headerData: JSON;
  data: RUMTabData;
  tabName: RUMChartTab;
  payload: RUMHeaderInput;
}

export const RUMGraphs = ({id, checkName, headerData, data, tabName, payload}: PageLoadTimeGraphProps) => {
  const reportSpec = ReportDefs[RUMChartTabParams[tabName]];
  return (
    <UpErrorBoundary>
      {reportSpec.trend.map((trend: never, idx: number) => (
        <UpErrorBoundary key={`trend-${idx}`}>
          <PageLoadTrend
            checkName={checkName}
            headerData={headerData}
            data={data.trend[idx]}
            reportSpec={{...reportSpec, trend: trend}}
          />
          {idx !== 0 && idx !== data.trend.length && <hr className="my-4" />}
        </UpErrorBoundary>
      ))}
      <UpErrorBoundary>
        <SectionDistributionGraph checkName={checkName} hist={data.hist} donut={data.donut} reportSpec={reportSpec} />
      </UpErrorBoundary>
      <UpErrorBoundary>
        <SectionBreakdown checkName={checkName} reportSpec={reportSpec} breakdown={data.breakdown} />
      </UpErrorBoundary>
      <UpErrorBoundary>
        <SectionSegments id={id} tab={tabName} checkName={checkName} reportSpec={reportSpec} payload={payload} />
      </UpErrorBoundary>
    </UpErrorBoundary>
  );
};
